<template>
	<div>
		<video-player :video="video" :options="options" class="rounded"/>
	</div>
	
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer.vue";

export default {
	props: {
		post: {
			type: Object,
			required: true
		}
	},
	components: {
		VideoPlayer
	},
	data() {
		return {
			player: null,
			options: {
				ratio: '16:9'
			}
		}
	},
	computed: {
		video() {
			return this.post.video;
		},
	}
}
</script>